import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Grid,
    Button,
} from '@material-ui/core';
import svg404 from '../../../assets/images/illustrations/404.svg';
import { NavLink as RouterLink } from 'react-router-dom';
import { ROUTES_PATH_CONFIG } from '../../config/routes';
import { ERROR_MESSAGES } from '../../constants';

export default function NotFound() {
    return (
        <Fragment>
            <div className="app-wrapper bg-white">
                <div className="app-main">
                    <div className="app-content p-0">
                        <div className="app-inner-content-layout--main">
                            <div className="flex-grow-1 w-100 d-flex align-items-center">
                                <div className="bg-composed-wrapper--content">
                                    <div className="hero-wrapper bg-composed-wrapper min-vh-100">
                                        <div className="flex-grow-1 w-100 d-flex align-items-center">
                                            <Grid
                                                item
                                                lg={6}
                                                md={9}
                                                className="px-4 px-lg-0 mx-auto text-center text-black">
                                                <img
                                                    src={svg404}
                                                    className="w-50 mx-auto d-block my-5 img-fluid"
                                                    alt="..."
                                                />

                                                <h3 className="font-size-xxl line-height-sm font-weight-light d-block px-3 mb-3 text-black-50">
                                                    {ERROR_MESSAGES.PAGE_NOT_FOUND}
                                                </h3>
                                                <Button
                                                    component={RouterLink}
                                                    to={ROUTES_PATH_CONFIG.APP.signin}
                                                    color="primary"
                                                    variant="contained"
                                                    className="text-white">
                                                    <span className="btn-wrapper--icon">
                                                        <FontAwesomeIcon icon={['fas', 'home']} />
                                                    </span>
                                                    <span className="btn-wrapper--label">
                                                        Back
                                                    </span>
                                                </Button>
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
